import util from '../util'

let controller = 'Quiz'
export default Object.assign({}, util.GetCrud(controller, null), {
	ListarPorCodigoBloqueio: function (codigoBloqueio) {
		return util.Axios.Get(controller + `/${codigoBloqueio}/Bloqueados`)
	},
	ListarPerguntas: function (codigo) {
		return util.Axios.Get(controller + `/${codigo}/Perguntas`)
	},
})
